import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './EmptyList.module.scss';

const cx = classNames.bind(styles);

const EmptyList = ({ message = 'No items found', className }) => {
  return <div className={cx(['container', className])}>{message}</div>;
};

EmptyList.propTypes = {
  message: PropTypes.string,
  className: PropTypes.string,
};

export default EmptyList;
